import {AfterViewInit, Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Countries} from '../../../models/countries.interface';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {CountriesService} from '../../../services/countries.service';
import {User} from '../../../../kf-data-entry/models/user.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {appConfig} from '../../../../config/config';

@Component({
  selector: 'app-edit-country',
  templateUrl: './edit-country.component.html',
  styleUrls: ['./edit-country.component.scss']
})
export class EditCountryComponent implements OnInit, AfterViewInit {

  pageSizes = appConfig.pageSizes;
  countryCoordinators!: User[];
  pageSize = 5;
  totalElements!: number;
  displayedColumns: string[] = ['name', 'firstName'];
  private page: PageRequest = {page: 0, size: 5, sort: 'name', direction: 'asc'};
  regions = [
    {value: 'EU', name: 'EUROPE'},
    {value: 'AFRICA', name: 'AFRICA'},
    {value: 'ASIA', name: 'ASIA'},
    {value: 'NORTH_AMERICA', name: 'NORTH AMERICA'},
    {value: 'LATIN_AMERICA', name: 'LATIN AMERICA'},
    {value: 'OCEANIA', name: 'OCEANIA'},
  ];

  countryEditForm = this.formBuilder.group({
    code: ['', Validators.required],
    name: ['', Validators.required],
    region: ['', Validators.required],
  });

  get codeControl(): FormControl {
    return this.countryEditForm.get('code') as FormControl;
  }
  get nameControl(): FormControl {
    return this.countryEditForm.get('name') as FormControl;
  }
  get regionControl(): FormControl {
    return this.countryEditForm.get('region') as FormControl;
  }

  @Output()
  updateEvent: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(@Inject(MAT_DIALOG_DATA) public data: Countries,
              private dialogRef: MatDialogRef<EditCountryComponent>,
              private readonly formBuilder: FormBuilder,
              private readonly countriesService: CountriesService) { }

  ngOnInit(): void {
    if (this.data.code) {
      this.codeControl.setValue(this.data.code);
    }
    if (this.data.name) {
      this.nameControl.setValue(this.data.name);
    }
    if (this.data.region) {
      this.regionControl.setValue(this.data.region);
    }

    this.getCoCo();
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.page = {page: 0, size: this.pageSize, sort: active, direction};
    this.getCoCo();
  }

  onPageChange(event: PageEvent): void {
    this.page = {page: event.pageIndex, size: event.pageSize};
    this.getCoCo();
  }

  sendEditionRequest(): void {
    const dto: Countries | null = this.getEditionDto();
    if (dto) {
      this.countriesService.editCountry(dto).subscribe(
        () => {
          this.updateEvent.emit();
          this.closeDialog();
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getCoCo(): void {
    this.countriesService.getCountryCoordinators(this.data.id, this.page).subscribe(
      (data) => {
        this.countryCoordinators = data.content;
        this.pageSize = data.size;
        this.totalElements = data.totalElements;
      }
    );
  }

  private getEditionDto(): Countries {
    return {
      id: this.data.id,
      code: this.codeControl.value,
      name: this.nameControl.value,
      region: this.regionControl.value,
      status: this.data.status,
      isEUMember: this.data.isEUMember ? this.data.isEUMember : this.regionControl.value === 'EU'
    };
  }

}
